import React, { useMemo } from 'react';
import Link from 'components/shared/Link';
import { NavigationItem } from 'components/navigation/utils/libs';
import { getNavigationItemUrl } from 'components/navigation/utils/getNavigationItemUrl';
import { Icon } from '@kontentino/ui';
import clsx from 'clsx';
import { VerticalMenuItemWrapper } from '../VerticalMenuItemWrapper';
import { useVerticalNavigation } from '../provider/VerticalNavigationProvider';
import useBoolean from 'utils/hooks/useBoolean';

type Props = {
  item: NavigationItem;
  isActive?: boolean;
};
const MenuLink: React.FC<Props> = ({ item, isActive }) => {
  const [isHovered, setIsHovered] = useBoolean(false);
  const { onMouseEnter } = useVerticalNavigation();

  return useMemo(() => {
    return (
      <Link
        onClick={(e) => {
          if (!(item.url || item.routerUrl)) {
            e.preventDefault();
          }
        }}
        to={getNavigationItemUrl(item)}
        isRouterLink={!!item.routerUrl}
        data-name={`navigation-link-${item.key}`}
        data-cy={`navigation-link-${item.key}`}
        onMouseEnter={() => {
          setIsHovered.on();
          if (item.key && !item.isPageSubmenu && !!item.items?.length) {
            onMouseEnter(item.key);
          }
        }}
        onMouseLeave={() => {
          setIsHovered.off();
        }}
      >
        <VerticalMenuItemWrapper
          isActiveMenu={isActive}
          className="tw-flex tw-h-auto tw-min-h-[46px] tw-flex-col tw-items-center hover:tw-text-primary-100"
        >
          <span
            className={clsx(
              'tw-min-h-8 tw-flex tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-p-1',
              {
                'tw-rounded-md tw-bg-primary-10': isHovered || isActive,
              },
            )}
          >
            {item.icon &&
              (typeof item.icon === 'object' && 'prefix' in item.icon ? (
                <Icon icon={item.icon} size="lg" />
              ) : (
                item.icon
              ))}
          </span>
          <span className="tw-text-center tw-text-[9px] tw-leading-[14px]">
            {item.label}
          </span>
        </VerticalMenuItemWrapper>
      </Link>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive, isHovered, item.label]);
};

export default React.memo(MenuLink, (prevProps, nextProps) => {
  return (
    prevProps.item.key === nextProps.item.key &&
    prevProps.item.label === nextProps.item.label &&
    prevProps.isActive === nextProps.isActive
  );
});
